import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiFetch, api } from '../../shared/api'

/** Contract §4.3: IDs remain strings, status describes today in Berlin. */
export interface BargeldlosSchule {
  schoolId: string
  schulName: string
  bargeldlos: boolean
  seit: string | null
  offenerZeitraum: { ab: string; bis: null } | null
}

export interface BargeldlosListe {
  zeilen: BargeldlosSchule[]
  gesamt: number
  seite: number
  proSeite: number
}

export interface BargeldlosFilter {
  seite?: number
  proSeite?: number
  q?: string
  nurBargeldlos?: boolean
}

export interface BargeldlosAenderung {
  bargeldlos: boolean
  ab: string
}

export function useBargeldlosListe({ seite = 1, proSeite = 25, q = '', nurBargeldlos = false }: BargeldlosFilter = {}, enabled = true) {
  const suche = q.trim()
  return useQuery({
    queryKey: ['schulen-bargeldlos', seite, proSeite, suche, nurBargeldlos],
    queryFn: ({ signal }) => {
      const params = new URLSearchParams({ seite: String(seite), proSeite: String(proSeite), q: suche, nurBargeldlos: String(nurBargeldlos) })
      return apiFetch<BargeldlosListe>(`/api/schulen-bargeldlos?${params}`, { signal })
    },
    enabled,
    staleTime: 0,
  })
}

export function useSetBargeldlos() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ schoolId, bargeldlos, ab }: BargeldlosAenderung & { schoolId: string }) =>
      api.put<BargeldlosSchule & { geaendert: boolean }>(`/api/schulen-bargeldlos/${encodeURIComponent(schoolId)}`, { bargeldlos, ab }),
    onSuccess: async () => {
      // Invalidate every search/page and office report whose expected days may change.
      await qc.invalidateQueries({ predicate: ({ queryKey }) =>
        queryKey[0] === 'schulen-bargeldlos' || queryKey[0] === 'schulen'
        || (typeof queryKey[0] === 'string' && queryKey[0].startsWith('kassenbuch-')),
      })
    },
  })
}
